import { useDispatch, useSelector } from 'react-redux'
import { dadosIniciais, inputs } from '../../../state/slices/formSlice'
import React from 'react'

const Input = (props) => {
    let modulo = props.modulo
    let index = props.index
    let subModulo = props.subModulo
    let indexSub = props.indexSub
    const dispatch = useDispatch()
    const modo = useSelector((state) => state.addForm.modo)
    const ficha = useSelector((state) => state.addForm.ficha)
    const mediaWeb = window.matchMedia("(min-width:600px)").matches
    const widthDiv = mediaWeb ? props.widthDiv : props.widthMobile
    const width = mediaWeb ? props.widthWeb : props.widthMobile

    const estilo = {
        principal: {
            display: props.componentDisplay, width: widthDiv, marginRight: props.marginR,
            textAlign: "left", color: "#484848", marginTop: "2vh"
        },
        input: {
            width: width, backgroundColor: "#00000000", border: "1px solid #00000029", borderRadius: "5px",
            minHeight: "5px"
        }
    }

    // ==========================
    // Funções auxiliares SHIFT+F3
    // ==========================

    function paraTitleCase(texto) {
        return String(texto ?? '')
            .toLowerCase()
            .replace(/\S+/g, palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
    }

    function proximaVariacaoDeCaixa(texto) {
        if (texto === null || texto === undefined) return texto

        const s = String(texto)
        const upper = s.toUpperCase()
        const lower = s.toLowerCase()
        const title = paraTitleCase(s)

        // Ciclo: MAIÚSCULA -> minúscula -> Capitalizado -> MAIÚSCULA...
        if (s === upper) {
            return lower
        } else if (s === lower) {
            return title
        } else {
            return upper
        }
    }

        function handleKeyDown(e) {
        if (!(e.shiftKey && e.key === 'F3')) return

        e.preventDefault()

        const el = e.target
        const fullValue = el.value || ''

        const start = typeof el.selectionStart === 'number' ? el.selectionStart : 0
        const end = typeof el.selectionEnd === 'number' ? el.selectionEnd : 0
        const hasSelection = start !== end

        let nextValue = fullValue

        if (hasSelection) {
            const selected = fullValue.slice(start, end)
            const replaced = proximaVariacaoDeCaixa(selected)

            // troca só o trecho selecionado
            nextValue = fullValue.slice(0, start) + replaced + fullValue.slice(end)

            // atualiza o input e mantém a seleção no novo trecho
            el.value = nextValue
            const newEnd = start + String(replaced).length
            el.setSelectionRange(start, newEnd)
        } else {
            // sem seleção: comporta como hoje (texto todo)
            nextValue = proximaVariacaoDeCaixa(fullValue)
            el.value = nextValue

            // mantém o cursor onde estava (se possível)
            const caret = start
            el.setSelectionRange(caret, caret)
        }

        const fakeEvent = {
            target: {
                name: el.name,
                value: nextValue
            }
        }

        dispatch(inputs({ e: fakeEvent, modulo, index, subModulo, indexSub }))
    }

    return (
        <>
            {RenderInput()}
        </>
    )

    function RenderInput() {
        let object = []
        if (ficha[modulo] && ficha[modulo][index]) {
            //Alterei aqui de (submodulo) para (ficha[modulo][index][subModulo])
            if (ficha[modulo][index][subModulo]) var valor = ficha[modulo][index][subModulo][indexSub]
            else var valor = ficha[modulo][index][props.nome]
        }
        if (!valor) {
            object.push(
                <>
                    <div style={estilo.principal}>
                        <div>{props.label}</div>
                        <input
                            style={estilo.input}
                            type={props.tipo}
                            name={props.nome}
                            onKeyDown={handleKeyDown}
                            onChange={e => dispatch(inputs({ e, modulo, index, subModulo, indexSub }))}
                        />
                    </div>
                </>
            )
        }
        else if (valor && modo === "view") {
            var ano = ''
            if (ficha.dadosIniciais[0].data && props.nome === "tv") ano = `/${ficha.dadosIniciais[0].data.slice(0, 4)}`
            if (props.nome === "data") {
                object.push(
                    <>
                        <div style={estilo.principal}>
                            <div>{props.label}</div>
                            <input style={estilo.input} type={props.tipo} value={valor} />
                        </div>
                    </>
                )
            } else {
                object.push(
                    <>
                        <div style={estilo.principal}>
                            <div>{props.label}</div>
                            <div style={estilo.input}>{valor + ano}</div>
                        </div>
                    </>
                )
            }
        }
        else {
            object.push(
                <>
                    <div style={estilo.principal}>
                        <div>{props.label}</div>
                        <input
                            style={estilo.input}
                            type={props.tipo}
                            name={props.nome}
                            defaultValue={valor}
                            onKeyDown={handleKeyDown}
                            onChange={e => dispatch(inputs({ e, modulo, index, subModulo, indexSub }))}
                        />
                    </div>
                </>
            )
        }
        return object
    }
}

export default Input
